import { useEffect, useState } from 'react';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="https://public.readdy.ai/ai/img_res/56f54be7-05b6-4d58-a7f9-34c35e6e2d40.png" alt="COMAGRA S.R.L." className="h-10 w-10 object-contain" />
            <span className={`text-sm font-light tracking-[3px] uppercase ${scrolled ? 'text-gray-900' : 'text-white'}`}>COMAGRA S.R.L.</span>
          </div>
          <div className="flex items-center gap-8">
            <a href="#home" className={`text-sm font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'}`}>Home</a>
            <a href="#about" className={`text-sm font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'}`}>About</a>
            <a href="#products" className={`text-sm font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'}`}>Products</a>
            <a href="#features" className={`text-sm font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'}`}>Features</a>
            <a href="#contact" className={`text-sm font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'}`}>Contact</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="min-h-screen flex">
        {/* Left Panel */}
        <div className="w-2/5 bg-[#1a1a1a] flex flex-col justify-center px-16 relative">
          <div className="absolute inset-0 bg-gradient-to-br from-black/30 via-black/20 to-black/40"></div>
          <div className="relative z-10">
            <h1 className="text-7xl font-bold text-white/95 leading-tight mb-8">
              <div className="mb-2">iOS app</div>
              <div className="ml-3 mb-2">development</div>
              <div className="ml-6">company</div>
            </h1>
            <p className="text-2xl text-[#b8b8b8] font-light max-w-md">Modern applications for enhanced mobile experience</p>
          </div>
        </div>

        {/* Right Panel */}
        <div className="w-3/5 bg-[#f5f3f0] flex items-center justify-center p-16 relative overflow-hidden">
          <div className="relative w-full h-full flex items-center justify-center">
            {/* Card 1 - VPN */}
            <div className="absolute top-20 left-12 w-80 h-96 bg-white rounded-[32px] shadow-[0_20px_60px_rgba(0,0,0,0.08)] border-2 border-white transform rotate-[8deg] overflow-hidden">
              <img src="https://public.readdy.ai/ai/img_res/9c274923aaa88046e6802f7da621ba50.jpg" alt="VPN App" className="w-full h-full object-cover object-top" />
            </div>
            
            {/* Card 2 - Cleaner (Center, Largest) */}
            <div className="relative w-96 h-[480px] bg-white rounded-[32px] shadow-[0_20px_60px_rgba(0,0,0,0.12)] border-2 border-white overflow-hidden z-10">
              <img src="https://readdy.ai/api/search-image?query=modern%20minimalist%20phone%20cleaner%20mobile%20app%20interface%20screenshot%20with%20clean%20white%20background%20showing%20storage%20optimization%20and%20cleaning%20tools%2C%20professional%20iOS%20design%20with%20simple%20geometric%20elements%20and%20coral%20accent%20colors&width=384&height=480&seq=cleaner-app-1&orientation=portrait" alt="Cleaner App" className="w-full h-full object-cover object-top" />
            </div>
            
            {/* Card 3 - Additional */}
            <div className="absolute bottom-16 right-16 w-72 h-80 bg-white rounded-[32px] shadow-[0_20px_60px_rgba(0,0,0,0.08)] border-2 border-white transform -rotate-[5deg] overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=modern%20minimalist%20mobile%20app%20interface%20screenshot%20with%20clean%20white%20background%20showing%20elegant%20dashboard%20with%20simple%20icons%20and%20statistics%2C%20professional%20iOS%20design%20with%20simple%20geometric%20elements%20and%20blue%20accent%20colors&width=288&height=320&seq=app-interface-1&orientation=portrait" alt="App Interface" className="w-full h-full object-cover object-top" />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-32 bg-[#faf8f5] relative overflow-hidden">
        <div className="absolute top-32 right-20 text-[320px] font-serif text-[#f0f0f0] leading-none select-none">"</div>
        <div className="max-w-7xl mx-auto px-8">
          <div className="flex justify-end mb-12">
            <span className="inline-block px-5 py-2 bg-[#e8f4f8] text-[#2a2a2a] text-xs uppercase tracking-wider rounded-full font-medium">About</span>
          </div>
          <div className="ml-[15%] max-w-4xl relative z-10">
            <h2 className="text-5xl font-serif text-[#2a2a2a] leading-[1.4] mb-20">
              A team of experts developing modern applications for the iOS platform
            </h2>
            <p className="text-xl text-[#6a6a6a] leading-relaxed max-w-xl">
              Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
            </p>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="py-32 bg-[#0f0f0f]">
        <div className="max-w-7xl mx-auto px-8">
          <div className="mb-20">
            <div className="inline-block px-6 py-2 border-2 border-white rounded-full mb-10">
              <span className="text-xs text-white uppercase tracking-[2px] font-medium">Products</span>
            </div>
            <h2 className="text-6xl font-bold text-white">Mobile Applications</h2>
          </div>

          <div className="grid grid-cols-2 gap-10">
            {/* VPN App Card */}
            <div className="bg-white rounded-[28px] p-12 h-[420px] flex flex-col">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#667eea] to-[#764ba2] flex items-center justify-center mb-8">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-[#1a1a1a] mb-4">VPN Application</h3>
              <p className="text-lg text-[#666666] leading-relaxed">
                Secure your online presence with our advanced VPN solution. Featuring military-grade encryption, global server network, and lightning-fast connection speeds to protect your privacy and data across all your iOS devices.
              </p>
            </div>

            {/* Cleaner App Card */}
            <div className="bg-white rounded-[28px] p-12 h-[380px] flex flex-col">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#11998e] to-[#38ef7d] flex items-center justify-center mb-8">
                <i className="ri-delete-bin-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-[#1a1a1a] mb-4">Cleaner Application</h3>
              <p className="text-lg text-[#666666] leading-relaxed">
                Optimize your device performance with intelligent cleaning tools. Remove junk files, manage storage efficiently, and keep your iOS device running smoothly with our comprehensive cleaning solution.
              </p>
            </div>

            {/* Security Suite Card */}
            <div className="bg-white rounded-[28px] p-12 h-[360px] flex flex-col">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#f093fb] to-[#f5576c] flex items-center justify-center mb-8">
                <i className="ri-lock-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-[#1a1a1a] mb-4">Security Suite</h3>
              <p className="text-lg text-[#666666] leading-relaxed">
                Comprehensive security features designed to protect your mobile experience. Advanced threat detection and real-time protection keep your data safe from emerging security risks.
              </p>
            </div>

            {/* Performance Tools Card */}
            <div className="bg-white rounded-[28px] p-12 h-[440px] flex flex-col">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#fa709a] to-[#fee140] flex items-center justify-center mb-8">
                <i className="ri-speed-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-[#1a1a1a] mb-4">Performance Tools</h3>
              <p className="text-lg text-[#666666] leading-relaxed">
                Boost your device speed and efficiency with our suite of performance optimization tools. Monitor system resources, manage background processes, and ensure your iOS device operates at peak performance levels at all times.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-32 bg-[#1c1c1c]">
        <div className="max-w-7xl mx-auto px-8">
          <div className="text-center mb-24">
            <h2 className="text-6xl font-serif text-white mb-6">Features</h2>
            <p className="text-xl text-[#b8b8b8]">Enhancing your mobile experience</p>
          </div>

          <div className="flex gap-8 overflow-x-auto pb-8 scrollbar-hide">
            {/* Feature 1 */}
            <div className="min-w-[380px] bg-[#f9f7f4] rounded-3xl p-10 flex flex-col">
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className="ri-shield-star-line text-4xl text-[#ff6b5a]"></i>
              </div>
              <h3 className="text-3xl font-bold text-[#1a1a1a] mb-4">Advanced Security</h3>
              <p className="text-lg text-[#5a5a5a] leading-relaxed mb-6">
                Military-grade encryption and advanced security protocols protect your data and privacy across all applications and network connections.
              </p>
              <div className="mt-auto pt-4 border-t border-[#ff6b5a]/20"></div>
            </div>

            {/* Feature 2 */}
            <div className="min-w-[380px] bg-[#f9f7f4] rounded-3xl p-10 flex flex-col">
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className="ri-flashlight-line text-4xl text-[#ff6b5a]"></i>
              </div>
              <h3 className="text-3xl font-bold text-[#1a1a1a] mb-4">Lightning Fast</h3>
              <p className="text-lg text-[#5a5a5a] leading-relaxed mb-6">
                Optimized performance ensures instant response times and seamless operation, making your mobile experience smooth and efficient.
              </p>
              <div className="mt-auto pt-4 border-t border-[#ff6b5a]/20"></div>
            </div>

            {/* Feature 3 */}
            <div className="min-w-[380px] bg-[#f9f7f4] rounded-3xl p-10 flex flex-col">
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className="ri-palette-line text-4xl text-[#ff6b5a]"></i>
              </div>
              <h3 className="text-3xl font-bold text-[#1a1a1a] mb-4">Intuitive Design</h3>
              <p className="text-lg text-[#5a5a5a] leading-relaxed mb-6">
                Beautiful, user-friendly interfaces designed following iOS guidelines ensure a natural and delightful user experience on every screen.
              </p>
              <div className="mt-auto pt-4 border-t border-[#ff6b5a]/20"></div>
            </div>

            {/* Feature 4 */}
            <div className="min-w-[380px] bg-[#f9f7f4] rounded-3xl p-10 flex flex-col">
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className="ri-refresh-line text-4xl text-[#ff6b5a]"></i>
              </div>
              <h3 className="text-3xl font-bold text-[#1a1a1a] mb-4">Regular Updates</h3>
              <p className="text-lg text-[#5a5a5a] leading-relaxed mb-6">
                Continuous improvements and new features keep our applications at the forefront of mobile technology and security standards.
              </p>
              <div className="mt-auto pt-4 border-t border-[#ff6b5a]/20"></div>
            </div>

            {/* Feature 5 */}
            <div className="min-w-[380px] bg-[#f9f7f4] rounded-3xl p-10 flex flex-col">
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className="ri-customer-service-line text-4xl text-[#ff6b5a]"></i>
              </div>
              <h3 className="text-3xl font-bold text-[#1a1a1a] mb-4">24/7 Support</h3>
              <p className="text-lg text-[#5a5a5a] leading-relaxed mb-6">
                Our dedicated support team is always available to assist you with any questions or issues you may encounter while using our applications.
              </p>
              <div className="mt-auto pt-4 border-t border-[#ff6b5a]/20"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-32 bg-[#faf8f5]">
        <div className="max-w-6xl mx-auto px-8">
          <h2 className="text-5xl font-bold text-[#2a2a2a] text-center mb-16">Contact</h2>
          
          <div className="grid grid-cols-2 gap-20">
            {/* Left Column - Address Information */}
            <div className="space-y-8">
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-map-pin-line text-xl text-[#ff6b5a]"></i>
                  </div>
                  <span className="text-sm uppercase tracking-[1.5px] text-[#888888] font-medium">Address</span>
                </div>
                <p className="text-2xl text-[#2a2a2a] ml-8">RIVADAVIA 560</p>
              </div>

              <div>
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-building-line text-xl text-[#ff6b5a]"></i>
                  </div>
                  <span className="text-sm uppercase tracking-[1.5px] text-[#888888] font-medium">City</span>
                </div>
                <p className="text-2xl text-[#2a2a2a] ml-8">Federal</p>
              </div>

              <div>
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-inbox-line text-xl text-[#ff6b5a]"></i>
                  </div>
                  <span className="text-sm uppercase tracking-[1.5px] text-[#888888] font-medium">Zip Code</span>
                </div>
                <p className="text-2xl text-[#2a2a2a] ml-8">E3180CUL</p>
              </div>

              <div>
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-global-line text-xl text-[#ff6b5a]"></i>
                  </div>
                  <span className="text-sm uppercase tracking-[1.5px] text-[#888888] font-medium">Country</span>
                </div>
                <p className="text-2xl text-[#2a2a2a] ml-8">Argentina</p>
              </div>
            </div>

            {/* Right Column - Communication Information */}
            <div className="space-y-8">
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-xl text-[#ff6b5a]"></i>
                  </div>
                  <span className="text-sm uppercase tracking-[1.5px] text-[#888888] font-medium">Email</span>
                </div>
                <p className="text-2xl text-[#2a2a2a] ml-8">help@comagrasrl.com</p>
              </div>

              <div>
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-line text-xl text-[#ff6b5a]"></i>
                  </div>
                  <span className="text-sm uppercase tracking-[1.5px] text-[#888888] font-medium">Phone</span>
                </div>
                <p className="text-2xl text-[#2a2a2a] ml-8">+1 9109811898</p>
              </div>
            </div>
          </div>

          {/* Decorative Line */}
          <div className="flex justify-center mt-16">
            <div className="w-32 h-0.5 bg-[#ff6b5a]"></div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0a2e2c] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="world-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
                <circle cx="50" cy="50" r="1" fill="#0f3835" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#world-pattern)" />
          </svg>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-8 py-16">
          <div className="flex justify-between items-start mb-16">
            {/* Left Section */}
            <div className="w-[35%]">
              <div className="flex items-center gap-2 mb-10">
                <img src="https://public.readdy.ai/ai/img_res/56f54be7-05b6-4d58-a7f9-34c35e6e2d40.png" alt="COMAGRA S.R.L." className="h-8 w-8 object-contain" />
                <span className="text-xl font-serif">COMAGRA S.R.L.</span>
                <span className="w-2 h-2 rounded-full bg-[#ff6b5a]"></span>
              </div>
              <p className="text-3xl font-serif text-white leading-tight max-w-xs">
                Stay updated with our latest releases
              </p>
            </div>

            {/* Right Navigation Grid */}
            <div className="w-[65%] grid grid-cols-4 gap-16">
              <div>
                <h4 className="text-base font-bold uppercase tracking-wider mb-5">Home</h4>
                <ul className="space-y-4">
                  <li><a href="#home" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Overview</a></li>
                  <li><a href="#about" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Mission</a></li>
                  <li><a href="#about" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Team</a></li>
                </ul>
              </div>

              <div>
                <h4 className="text-base font-bold uppercase tracking-wider mb-5">Products</h4>
                <ul className="space-y-4">
                  <li><a href="#products" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">VPN App</a></li>
                  <li><a href="#products" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Cleaner App</a></li>
                  <li><a href="#products" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">All Products</a></li>
                </ul>
              </div>

              <div>
                <h4 className="text-base font-bold uppercase tracking-wider mb-5">Features</h4>
                <ul className="space-y-4">
                  <li><a href="#features" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Security</a></li>
                  <li><a href="#features" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Performance</a></li>
                  <li><a href="#features" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Interface</a></li>
                </ul>
              </div>

              <div>
                <h4 className="text-base font-bold uppercase tracking-wider mb-5">Company</h4>
                <ul className="space-y-4">
                  <li><a href="#about" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">About Us</a></li>
                  <li><a href="#contact" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Contact</a></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Lower Footer Bar */}
          <div className="pt-8 border-t border-white/10 flex items-center justify-between">
            <p className="text-sm text-white/50">© 2025 COMAGRA S.R.L. All rights reserved</p>
            
            <div className="flex items-center gap-5">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg border-[1.5px] border-white/30 flex items-center justify-center hover:border-white/60 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg border-[1.5px] border-white/30 flex items-center justify-center hover:border-white/60 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg border-[1.5px] border-white/30 flex items-center justify-center hover:border-white/60 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg border-[1.5px] border-white/30 flex items-center justify-center hover:border-white/60 transition-colors cursor-pointer">
                <i className="ri-facebook-line text-lg"></i>
              </a>
            </div>

            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-white/50 hover:text-white/70 transition-colors cursor-pointer whitespace-nowrap">Powered by Readdy</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
